<template>
  <div id="app">
    <div id="GDMapContainer" style="width:400px;height:400px;display:none"></div>
    <div class="contain-content">
         <router-view></router-view>
    </div>
     <!--尾部tab-->
  <div class="container-bottom" v-show="$route.meta.showFooter">
      <bottom-nav  class="tab"></bottom-nav>
    </div>
  </div>
</template>

<script>
// import bottomNav from './components/index/index'
import bottomNav from './components/bottomnav/bottom-nav'
import index from './components/index/index'

export default {
  name: 'App',
  components: {
    bottomNav,
    index
  },
  created:function(){
    // 页面载入前恢复本地数据到store
    this.getDate();
    // 页面关闭时保存 store数据到本地 
    window.addEventListener("beforeunload", this.saveDate)
    window.addEventListener("unload", this.saveDate) //微信浏览器采用此方式
  },
  methods: {
    getDate(){
      if (this.commonUtil.getCookie("store")) {
        if(!!Object.assign){
          this.$store.replaceState(Object.assign(this.$store.state,JSON.parse(this.commonUtil.getCookie("store"))))
        }
      }
    },
    saveDate(){
      
      if (this.commonUtil.isLogin()) {
        const curTimeStamp = new Date().getTime();
        const expriyTimeStamp = Number(this.$store.state.expriyTimeStamp);
        if (expriyTimeStamp) {
          const leftIndate = expriyTimeStamp - curTimeStamp;
          this.commonUtil.setCookie("store",JSON.stringify(this.$store.state),leftIndate);
        }
      }
    },
  },
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  position: relative;
  /* min-height: 100vh; */
  height: 100%;
  width: 100%;
  background-color: #F8F8F8;
}
body{
   background: url("../static/images/banner_1.jpg") -10000px -10000px no-repeat,
  url("../static/images/banner_2.jpg") -10000px -10000px no-repeat,
  url("../static/images/banner_3.jpg") -10000px -10000px no-repeat,
  url("../static/images/adv.png") -10000px -10000px no-repeat,
  url("../static/images/popup.png") -10000px -10000px no-repeat
}
#app .container-bottom {
    position: fixed;
    z-index: 1;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 10%;

}
.contain-content{
  /* overflow-y: scroll; */
  height: 100%;
}
body, html {
    overflow-x: hidden;
    overflow-y: auto;
    max-width: 640px;
    margin:  0 auto;
    height: 100%;
    -webkit-overflow-scrolling: touch;
}
</style>



// WEBPACK FOOTER //
// src/App.vue